import { useEffect, useState } from "react";
import { convertDataToObject } from "./convertDataToObject";
import { Message, Messages, miroTeamId, miroUserId } from "./useDataStoreMiro";
import config from "../../config"
import { doc, getDoc, setDoc } from "firebase/firestore";
import { fbDb } from "./useFirestore";
import { merge } from "lodash";
import { convertObjectToData } from "./convertObjectToData";
import { generateUID } from "../../components/Utils/generateUID";
import { applyMessagesToData, messagesToPathObjects } from "./applyMessagesToData";

let browserId = localStorage.getItem('browserId');
if (!browserId) {
    browserId = generateUID();
    localStorage.setItem('browserId', browserId)
}
export const uniqueSessionId = browserId + "-" + generateUID();

export function useDataStoreFirestore<Type>(initialState: Type, dataKey: string, withWhom: "mine" | "shared") {
    // Make sure we have a key set
    if (dataKey.length === 0) throw new Error("Key for data store not set");

    const [state, setState] = useState<Type>(convertDataToObject<Type>(initialState))

    // Get the data that is already in Airtable
    useEffect(() => {
        let dataPath: string[] = [];
        if (withWhom === "mine") {
            dataPath = [`miroUsers`, miroUserId, `settings`, config.id, "tools", dataKey]
        } else {
            dataPath = [`miroTeams`, miroTeamId, `settings`, config.id, "tools", dataKey]
        }

        let cancelled = false;

        // get snapshot of current doc
        // TODO: consider but check security!! : reduce data fetching by storing the data in the browser and check the partial updates below first. If I am aware of that last change then pull data from browser instead of from firestore
        const docSnap = getDoc(doc(fbDb, dataPath.join("/"))).then((doc) => {
            if (doc.exists() && !cancelled) {
                setState(convertDataToObject(doc.data()) as unknown as Type);
            }
        })

        // // subscribe to partial updates
        // let first = true;
        // const cleanup = onFirestoreSnapshot([...dataPath, "u", "l"], (doc) => {
        //     if (first) {
        //         first = false;
        //         return;
        //     }

        //     if (doc.exists()) {
        //         const action = doc.data();
        //         if (action.id !== uniqueSessionId) {
        //             setState((s) => {
        //                 const changed = applyMessagesToData(action.messages, convertObjectToData(s))
        //                 return convertDataToObject<any>(changed);
        //             });
        //         }
        //     }
        // })

        return () => {
            cancelled = true;
            // cleanup();
        }

    }, []);

    async function dispatch<Type, dataTypes>(
        messages: Messages<dataTypes> | Message<dataTypes>
    ) {

        if (!Array.isArray(messages)) messages = [messages];
        // const mergedDataKey = await mergeDataKey(dataKey, addUserId)

        // Update internal state
        setState((s) => {
            const changedData = applyMessagesToData<dataTypes>(messages, convertObjectToData(s));
            return convertDataToObject<any>(changedData);
        });

        // Update external state
        let dataPath: string[] = [];
        if (withWhom === "mine") {
            dataPath = [`miroUsers`, miroUserId, `settings`, config.id, "tools", dataKey]
        } else {
            dataPath = [`miroTeams`, miroTeamId, `settings`, config.id, "tools", dataKey]
        }

        // // Notify updates
        // await setDoc(doc(fbDb, [...dataPath, "u", "l"].join("/")), {
        //     id: uniqueSessionId,
        //     messages: messages
        // });

        const newPathObjects = messagesToPathObjects(messages, convertObjectToData(state))

        const newCombinedPathObject = {};
        for (const n of newPathObjects) {
            merge(newCombinedPathObject, n);
        }

        await setDoc(doc(fbDb, dataPath.join("/")), newCombinedPathObject, { merge: true });

    }

    return [state, dispatch]
}